import {useMutation} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {showHttpErrorToast} from '@common/http/show-http-error-toast';

interface Payload {
  id: number;
  delete?: boolean;
}

export function useDeleteReports(model_type: string) {
  return useMutation({
    mutationFn: (payload: Payload) => deleteReports(payload, model_type),

    onError: r => showHttpErrorToast(r),
  });
}

function deleteReports(
  payload: Payload,
  model_type: string,
): Promise<Response> {
  return apiClient
    .delete(`report/${model_type}/${payload.id}`, {
      data: {
        delete: payload.delete,
      },
    })
    .then(r => r.data);
}
